var React = require('react');

function Arrowblueleft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.067 25L13.067 14.3774L36 14.3774L36 11.5257L10.2004 11.5257L10.2004 18.4886L4.1566 12.904L13.067 4.03992L13.067 -2.00486e-06L1.05123e-06 12.9753L13.067 25Z","fill":"#4285F4"}));
}

Arrowblueleft.defaultProps = {"width":"36","height":"25","viewBox":"0 0 36 25","fill":"none"};

module.exports = Arrowblueleft;

Arrowblueleft.default = Arrowblueleft;
